import './App.css';
import Helmet from "react-helmet";

//import favicon from './img/Toby_Morgan.jpg';

//Components of the portfolio
import AboutMe from './components/about';
import Projects from './components/projects';
import Outro from './components/outro';
import Contact from './components/contact';

function App() {
  return (
  <div className="App">
  <html lang="en">
    <Helmet>
      <title>Toby Morgan's Portfolio</title>
      <meta name="author" content="Toby Morgan"/>
      <meta name="description" content="Portfolio and CV"/>
      {/**<link rel="icon" href={}></link>**/}
    </Helmet>
    <body>
      <header>
        <h1>Toby Morgan's Portfolio & CV</h1>
        <h2>Welcome to my portfolio!</h2>
      </header>
      <AboutMe/>
      <Projects/>
      <Outro/>
    </body>
    <footer>
      <Contact/>
    </footer>
  </html>
  </div>
  );
}

export default App;